import React, { Fragment, useEffect, useRef, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { DayPilot, DayPilotCalendar, DayPilotMonth, DayPilotNavigator } from "@daypilot/daypilot-lite-react";
import LayoutHOC from "../../LayoutHOC";
import { useFetchTaskGetOrgAccordingQuery } from "../../../utils/customer/customerTaskTable";
import useRequireAuth from "../../../utils/useRequireAuth";
import EditOptionsModal from "./EditOptionsModal";
import AddTaskModal from "../../customer/AddTaskModal";
import { RRule } from "rrule"; // Import rrule

import { useParams } from "react-router-dom";

import { format } from "date-fns";
import useDateWithDay from "../../../hooks/DateFormatter/useDateWithDay";
import { Dialog, Tooltip } from "@mui/material";
import useInitialLetters from "../../../hooks/LetterShow/useInitialLetters";
import SubTaskIcon from "../../Icons/SubTaskIcon";
import RecurrenceIcon from "../../Icons/RecurrenceIcon";
import EditOptionsTaskPodModal from "./EditOptionsTaskPodModal";
import AddTaskPodModal from "../AddTaskPodModal";
import { ReactComponent as RedDeleteIcon } from "../../../assets/images/redDeleteIcon.svg";
import { ReactComponent as BlueCalendarTimeIcon } from "../../../assets/images/blueCalendarTimeIcon.svg";
import AvatarName from "../../UniversalComponents/AvatarName";
import { safeDateIsoParts } from "../../../utils/utilityFunctions/dateUtility";
const getStartOfWeek = (date) => {
  const start = new Date(date);
  start.setDate(start.getDate() - start.getDay());
  start.setHours(0, 0, 0, 0);
  return start;
};

const getEndOfWeek = (date) => {
  const end = new Date(date);
  end.setDate(end.getDate() + (6 - end.getDay()));
  end.setHours(23, 59, 59, 999);
  return end;
};

const getStartOfMonth = (date) => {
  const start = new Date(date);
  start.setDate(1);
  start.setHours(0, 0, 0, 0);
  return start;
};

const getEndOfMonth = (date) => {
  const end = new Date(date);
  end.setMonth(end.getMonth() + 1, 0);
  end.setHours(23, 59, 59, 999);
  return end;
};

const TaskPodRecurrenceCalendar = ({
  setView,
  view,
  setStartDate,
  startDate,
  calendarData: taskRecurrenceAll,
  refetchCalendarData: taskRecurrenceFetch,
}) => {
  // console.log(defaultview, 9999)
  const { token } = useRequireAuth();

  console.warn(startDate, "startDate");

  // const [startDate, setStartDate] = useState(DayPilot.Date.today());

  const [events, setEvents] = useState([]);
  const [allDayTask, setAllDayTask] = useState([]);
  const [filteredAllDayTasks, setFilteredAllDayTasks] = useState([]);
  const [eventSearchQuery, setEventSearchQuery] = useState("");

  const [modalOpen, setModalOpen] = useState(null);

  // const { data: taskRecurrenceAll, refetch: taskRecurrenceFetch } = useFetchTaskGetOrgAccordingQuery({
  //   token,
  // });

  const [showCalendar, setShowCalendar] = useState(false);
  const [showEvents, setShowEvents] = useState(true);
  const [eventsSearch, setEventsSearch] = useState(false);
  const [hoveredEventId, setHoveredEventId] = useState(null);

  const [hoveredTask, setHoveredTask] = useState(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const debounceTimer = useRef(null);
  useEffect(() => {
    const handleHoverStart = (e) => {
      const {
        id,
        x,
        y,
        args,
        subject,
        start_date,
        end_date,
        start_time,
        end_time,
        category_id,
        sub_tasks,
        assigned_to,
      } = e.detail;
      // Debounce logic
      debounceTimer.current = setTimeout(() => {
        setHoveredTask({
          id,
          args,
          subject,
          start_date,
          end_date,
          start_time,
          end_time,
          category_id,
          sub_tasks,
          assigned_to,
        });
        setMousePos({ x, y });
      }, 700);
    };

    const handleHoverEnd = () => {
      clearTimeout(debounceTimer.current);
      setHoveredTask(null);
    };

    window.addEventListener("dp-hover-start", handleHoverStart);
    window.addEventListener("dp-hover-end", handleHoverEnd);
    // window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("dp-hover-start", handleHoverStart);
      window.removeEventListener("dp-hover-end", handleHoverEnd);
      // window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  useEffect(() => {
    if (taskRecurrenceAll) {
      const taskEvents = [];
      const dayweekalldaytask = [];

      taskRecurrenceAll.forEach((task) => {
        const startDateParts = task?.start_date?.split(" ");
        const endDateParts = task?.end_date?.split(" ");

        const startDate = new Date(`${startDateParts?.[0]}T${task.start_time}Z`);
        const endDate = new Date(`${endDateParts?.[0]}T${task.end_time}Z`);

        if (task.is_recurrence) {
          let rule = null;

          switch (task?.frequency) {
            case "daily":
              rule = new RRule({
                freq: RRule.DAILY,
                interval: task.intervals,
                byweekday:
                  task.daily_option === "every_weekday" ? [RRule.MO, RRule.TU, RRule.WE, RRule.TH, RRule.FR] : null,
                dtstart: startDate,
                until: endDate,
              });
              break;
            case "weekly":
              // rule = new RRule({
              //   freq: RRule.WEEKLY,
              //   interval: task.intervals,
              //   byweekday: task?.weekly_days ? task?.weekly_days?.split(',')?.map(day => RRule[day?.toUpperCase()]) : [],
              //   dtstart: startDate,
              //   until: endDate
              // });
              const weeklyDays = task.weekly_days ? task.weekly_days?.split(",") : [];
              const byweekday = weeklyDays
                .map((day) => {
                  switch (day?.toLowerCase()) {
                    case "monday":
                      return RRule.MO;
                    case "tuesday":
                      return RRule.TU;
                    case "wednesday":
                      return RRule.WE;
                    case "thursday":
                      return RRule.TH;
                    case "friday":
                      return RRule.FR;
                    case "saturday":
                      return RRule.SA;
                    case "sunday":
                      return RRule.SU;
                    default:
                      return null;
                  }
                })
                .filter(Boolean); // Filter out any null values

              if (byweekday.length === 0) {
                return;
              }

              try {
                rule = new RRule({
                  freq: RRule.WEEKLY,
                  interval: task.intervals,
                  byweekday: byweekday,
                  dtstart: startDate,
                  until: endDate,
                });
              } catch (error) {
                return;
              }
              break;
            case "monthly":
              // rule = new RRule({
              //   freq: RRule.MONTHLY,
              //   interval: task.intervals,
              //   bymonthday: task.day_of_month ? [task.day_of_month] : [],
              //   dtstart: startDate,
              //   until: endDate
              // });
              if (task.monthly_option === "specific_day") {
                rule = new RRule({
                  freq: RRule.MONTHLY,
                  interval: task.intervals,
                  bymonthday: task.day_of_month ? [task.day_of_month] : [],
                  dtstart: startDate,
                  until: endDate,
                });
              } else if (task.monthly_option === "weekday_of_month") {
                const weekNumberMap = {
                  first: 1,
                  second: 2,
                  third: 3,
                  fourth: 4,
                };
                const weekNumber = weekNumberMap[task.monthly_week];

                if (!weekNumber) {
                  return;
                }

                const weekdaysMap = {
                  sunday: RRule.SU,
                  monday: RRule.MO,
                  tuesday: RRule.TU,
                  wednesday: RRule.WE,
                  thursday: RRule.TH,
                  friday: RRule.FR,
                  saturday: RRule.SA,
                };
                const weekday = weekdaysMap[task?.day_of_week?.toLowerCase()];

                if (!weekday) {
                  return;
                }

                try {
                  rule = new RRule({
                    freq: RRule.MONTHLY,
                    interval: task.intervals,
                    byweekday: [weekday.nth(weekNumber)],
                    dtstart: startDate,
                    until: endDate,
                  });
                } catch (error) {
                  return;
                }
              }
              break;
            case "yearly":
              rule = new RRule({
                freq: RRule.YEARLY,
                interval: task.intervals,
                bymonth: task.monthly_day_of_month || [],
                bymonthday: task.day_of_month ? [task.day_of_month] : [],
                dtstart: startDate,
                until: endDate,
              });
              break;
            default:
              break;
          }

          // if (rule) {
          //   rule.all().forEach(date => {
          //     const dateOnly = date.toISOString().split('T')?.[0]; // Get the date part only

          //     taskEvents.push({
          //       start: `${dateOnly}T00:00:00Z`,
          //       end: `${dateOnly}T23:59:59Z`, // Full day event for that particular date
          //       text: task.subject,
          //       ...task
          //     });
          //   });
          // }

          if (rule) {
            rule.all().forEach((date) => {
              const dateOnly = date.toISOString()?.split("T")?.[0];

              // Check if there's an exception for this date
              const exception = task.exceptions?.find((exc) => exc.exception_date === dateOnly);

              const matchingStatus = task.recurrence_statuses?.find((status) => status.date === dateOnly);

              if (exception) {
                // Use exception details
                taskEvents.push({
                  start: `${exception.new_start_date}T${exception.new_start_time}Z`,
                  end: `${exception.new_end_date}T${exception.new_end_time}Z`,
                  text: exception.new_subject || task.subject,
                  ...task,
                  ...exception,

                  subject: exception?.new_subject,
                  category_id: exception?.new_category_id,
                  start_time: exception?.new_start_time,
                  end_time: exception?.new_end_time,
                  priority: exception?.new_priority,
                  task_pod: exception?.new_task_pod,
                  status: matchingStatus?.status,
                  description: exception?.new_description,
                  isException: true,
                });
              } else {
                // Regular occurrence

                taskEvents.push({
                  start: `${dateOnly}T${task.start_time}Z`,
                  end: `${dateOnly}T${task.end_time}Z`,
                  text: task.subject ?? "",
                  ...task,
                  isException: false,
                });
              }
            });
          }
        } else {
          // Handle single occurrence task and split into separate days if spanning multiple days
          // && startDate.toISOString()?.split('T')?.[0] !== endDate.toISOString()?.split('T')?.[0]

          if (task.start_time === "00:00:00" && task.end_time === "00:00:00") {
            const taskStart = safeDateIsoParts(task.start_date?.split(" ")[0], task.start_time);
            const taskEnd = safeDateIsoParts(task.end_date?.split(" ")[0], task.end_time);
            if (taskStart && taskEnd) {
              if (view === "Month") {
                taskEvents.push({
                  start: taskStart,
                  end: taskEnd,
                  text: task.subject,
                  ...task,
                });
              } else {
                dayweekalldaytask.push({
                  start: taskStart,
                  end: taskEnd,
                  text: task.subject,
                  ...task,
                });
              }
            }
          } else {
            let current = new Date(startDate);

            while (current <= endDate) {
              const dateOnly = current.toISOString()?.split("T")?.[0]; // Get the date part only

              // const matchingStatus = task.statuses?.find(
              //   (status) => status.status_date === dateOnly
              // );

              taskEvents.push({
                start: `${dateOnly}T${task.start_time}Z`,
                end: `${dateOnly}T${task.end_time}Z`, // Full day event for that particular date
                text: task.subject,
                ...task,
              });

              current.setDate(current.getDate() + 1); // Move to the next day
            }
          }
        }

        if (task?.sub_tasks && task?.sub_tasks?.length > 0) {
          task.sub_tasks.forEach((subTask) => {
            const startDate = subTask.start_date?.split(" ")[0]; // Get only the date part
            const endDate = subTask.end_date?.split(" ")[0];

            const startTime = subTask.start_time ?? "00:00"; // fallback
            const endTime = subTask.end_time ?? "00:30";

            // Combine and construct ISO strings without forcing 'Z' unless needed
            const startDateTimeString = `${startDate}T${startTime}`;
            const endDateTimeString = `${endDate}T${endTime}`;

            const subTaskStartDate = new Date(startDateTimeString);
            const subTaskEndDate = new Date(endDateTimeString);

            console.log({ startDateTimeString, subTaskStartDate }, "Start Debug");
            console.log({ endDateTimeString, subTaskEndDate }, "End Debug");

            if (subTask?.show_on_calendar && !isNaN(subTaskStartDate) && !isNaN(subTaskEndDate)) {
              dayweekalldaytask.push({
                start: subTaskStartDate.toISOString(),
                end: subTaskEndDate.toISOString(),
                text: subTask.subject,
                ...subTask,
              });
            } else {
              console.warn("Invalid sub-task date", subTask);
            }
          });
        }
      });

      setEvents(taskEvents);

      setAllDayTask(dayweekalldaytask);
    }
  }, [taskRecurrenceAll, view]);

  useEffect(() => {
    const filterAllDayTasks = () => {
      let filteredTasks = [];
      let viewStart, viewEnd;

      if (view === "Day") {
        viewStart = new Date(startDate);
        viewEnd = new Date(startDate);
        viewEnd.setDate(viewEnd.getDate() + 1);
        viewEnd.setMilliseconds(viewEnd.getMilliseconds() - 1); // End of the day
      } else if (view === "Week") {
        viewStart = getStartOfWeek(startDate);
        viewEnd = getEndOfWeek(startDate);
      } else if (view === "Month") {
        viewStart = getStartOfMonth(startDate);
        viewEnd = getEndOfMonth(startDate);
      }

      if (allDayTask?.length > 0) {
        filteredTasks = allDayTask.filter((event) => {
          const eventDate = new Date(event.start_date);
          return eventDate >= viewStart && eventDate <= viewEnd;
        });
      }
      setFilteredAllDayTasks(filteredTasks);
    };

    filterAllDayTasks();
  }, [view, startDate, allDayTask]);

  const filteredTasks = filteredAllDayTasks.filter(
    (event) =>
      event.text?.toLowerCase().includes(eventSearchQuery?.toLowerCase()) ||
      (event.priority && event.priority?.toLowerCase().includes(eventSearchQuery?.toLowerCase())) ||
      (event.owner && event.owner?.toLowerCase().includes(eventSearchQuery?.toLowerCase()))
  );

  const { getInitials } = useInitialLetters();

  const eventRender = (args) => {
    if (args.data.text) {
      args.element.innerHTML = args.data.text;
    }
  };

  // const onBeforeEventRender = (args) => {
  //   const isRecurrence = args.data.is_recurrence === 1;
  //   args.data.html = `<div style="font-size: 9px;">
  //                           <div class="flex justify-between">
  //                                  <span>${args.data.text}</span>
  //                                  ${isRecurrence ? '<span>🔄</span>' : ''}
  //                           </div>
  //                           </br>
  //                           <span>${args.data.status}</span>
  //                     </div>`;
  // };

  const onBeforeEventRender = (args) => {
    const isRecurrence = args.data.is_recurrence === 1;
    const { status, status_colour_code } = args.data;
    console.log("aakash args", args);
    const recurrenceIconHTML = isRecurrence ? ReactDOMServer.renderToString(<RecurrenceIcon />) : "";
    args.data.toolTip = null;
    args.data.cssClass = `hoverable-event-${args.data.id}`;
    args.data.html = `<div class="dp-hover-target w-full text-xs cursor-pointer"
       onmouseover="(function(e){ window.dispatchEvent(new CustomEvent('dp-hover-start', { detail: { id: '${args.data.id}',subject: '${args.data?.subject}',start_date: '${args.data?.start_date}',end_date: '${args.data?.end_date}',start_time: '${args.data?.start_time}',end_time: '${args.data?.end_time}' ,category: '${args.data?.category_id}',sub_tasks: '${args.data?.sub_tasks?.length}',assigned_to: '${args.data?.assigned_to?.[0]?.name}', x: e.clientX, y: e.clientY } })) })(event)"
    onmouseout="window.dispatchEvent(new CustomEvent('dp-hover-end'))" class="text-[9px] flex flex-col align-center gap-0.5 w-full bg-white rounded-md">
                        <div class="flex justify-between items-center w-full">
                            <div class="w-full">
                                <div class="flex justify-between w-full">
                                    <span class="capitalize truncate text-ellipsis w-full">${args.data.text}</span> 
                                </div> 
                            <div style="background-color:${status_colour_code}" class="bg-[${status_colour_code}] text-white px-2 py-1 rounded-md w-fit">${status}</div>
                        </div>
                        ${recurrenceIconHTML} 
                        </div>
                      </div>`;
  };

  const onTimeRangeSelected = (args) => {
    setModalOpen({ ...args, model: "addmodel" });
  };

  const handleEditFields = (selection) => {
    const Selectedaccordfield = { ...modalOpen, selection };
    setModalOpen(Selectedaccordfield);
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const date = new Date(dateString?.split(" ")?.[0]);
    return date.toLocaleDateString("en-GB", options);
  };

  const CalendarOpenNow = () => {
    setShowCalendar(!showCalendar);
  };

  const AllEventsExpand = () => {
    setShowEvents(!showEvents);
  };

  const AllEventSearch = () => {
    setEventsSearch(!eventsSearch);
  };

  // const AllTaskEventsEdit = (alleventedit) => {

  //   console.warn(allDayTask,"allDayTask")
  //   setModalOpen(alleventedit);

  // }
  const AllTaskEventsEdit = (alleventedit) => {
    const matchedTask = taskRecurrenceAll?.data?.find((task) =>
      alleventedit.parent_task_id ? task.id === alleventedit.parent_task_id : task.id === alleventedit.id
    );

    setModalOpen(matchedTask);
  };

  const formattedStartDate = useDateWithDay(new Date(startDate?.value));
  const onEventClick = (args) => {
    setModalOpen(args?.e?.data);
  };
  const handleEventMove = async (args) => {
    console.log(args, "args aajash");
    const { e, newStart, newEnd } = args;

    // const eventId = e.data.id;
    // const originalStart = e.data.start;
    // const originalEnd = e.data.end;

    // // Optionally show loading or confirmation
    // const approved = await checkApprovalFromBackend({
    //   id: eventId,
    //   newStart,
    //   newEnd,
    // });

    // if (approved) {
    //   // Apply the change manually
    //   const updated = events.map((event) =>
    //     event.id === eventId
    //       ? { ...event, start: newStart, end: newEnd }
    //       : event
    //   );
    //   setEvents(updated);
    // } else {
    //   // Revert event to original position
    //   DayPilot.Calendar.ref.calendar.events.update({
    //     ...e.data,
    //     start: originalStart,
    //     end: originalEnd,
    //   });

    //   // Optionally show a toast or dialog
    //   alert("Move rejected by server.");
    // }
  };

  return (
    <div className="flex flex-row">
      <div className="grow">
        {/* <div className="toolbar">
          <div className="toolbar-group">
            <button onClick={() => setView("Day")} className={view === "Day" ? "selected" : ""}>Day</button>
            <button onClick={() => setView("Week")} className={view === "Week" ? "selected" : ""}>Week</button>
            <button onClick={() => setView("Month")} className={view === "Month" ? "selected" : ""}>Month</button>
          </div>
          <button onClick={() => setStartDate(DayPilot.Date.today())} className="standalone">Today</button>
        </div> */}

        <div className="flex">
          <DayPilotCalendar
            viewType="Day"
            startDate={startDate}
            events={events}
            visible={view === "Day"}
            durationBarVisible={false}
            onTimeRangeSelected={onTimeRangeSelected}
            onEventClick={onEventClick}
            onEventMove={handleEventMove}
            onBeforeEventRender={onBeforeEventRender}
            headerDateFormat="dd MMM, yyyy"
          />

          <DayPilotCalendar
            viewType="Week"
            startDate={startDate}
            events={events}
            visible={view === "Week"}
            durationBarVisible={false}
            onTimeRangeSelected={onTimeRangeSelected}
            onEventClick={onEventClick}
            onEventMove={handleEventMove}
            onBeforeEventRender={onBeforeEventRender}
            headerDateFormat="dd MMM, yyyy"
          />
          <DayPilotMonth
            startDate={startDate}
            events={events}
            visible={view === "Month"}
            eventBarVisible={false}
            onTimeRangeSelected={onTimeRangeSelected}
            onBeforeEventRender={onBeforeEventRender}
            onEventClick={onEventClick}
            onEventMove={handleEventMove}
            onEventMouseOver={() => {
              console.log("on event Mouse Over");
            }}
            // theme="custom_month_day_pilot"
            cellHeightSpec="Fixed" // default
            eventHeight={40}
          />

          <div className="ms-3 w-[282px]">
            <button
              className="bg-DCEEF8 mb-2 rounded-t-md flex  justify-between items-center p-1 w-full"
              type="button"
              onClick={() => {
                CalendarOpenNow();
              }}
            >
              <div className="flex items-center">
                <div>
                  {/* <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path
                      d="M18.6667 4.38667C18.6658 3.5524 18.3339 2.75257 17.744 2.16265C17.1541 1.57274 16.3543 1.24092 15.52 1.24H14.9524V0.666667C14.9524 0.489856 14.8822 0.320286 14.7571 0.195262C14.6321 0.0702379 14.4625 0 14.2857 0C14.1089 0 13.9394 0.0702379 13.8143 0.195262C13.6893 0.320286 13.6191 0.489856 13.6191 0.666667V1.24H5.04813V0.666667C5.04813 0.489856 4.9779 0.320286 4.85287 0.195262C4.72785 0.0702379 4.55828 0 4.38147 0C4.20466 0 4.03509 0.0702379 3.91006 0.195262C3.78504 0.320286 3.7148 0.489856 3.7148 0.666667V1.24H3.14667C2.3124 1.24092 1.51257 1.57274 0.922651 2.16265C0.332735 2.75257 0.000917591 3.5524 0 4.38667V15.52C0.000917591 16.3543 0.332735 17.1541 0.922651 17.744C1.51257 18.3339 2.3124 18.6658 3.14667 18.6667H10.2753C11.3281 19.5237 12.6426 19.9942 14 20C15.5908 19.9982 17.1159 19.3655 18.2407 18.2407C19.3655 17.1159 19.9982 15.5908 20 14C19.9942 12.6426 19.5237 11.3281 18.6667 10.2753V4.38667ZM3.14667 2.57333H3.71427V3.14227C3.71427 3.31908 3.7845 3.48865 3.90953 3.61367C4.03455 3.7387 4.20412 3.80893 4.38093 3.80893C4.55774 3.80893 4.72731 3.7387 4.85234 3.61367C4.97736 3.48865 5.0476 3.31908 5.0476 3.14227V2.57333H13.618V3.14227C13.618 3.31908 13.6882 3.48865 13.8133 3.61367C13.9383 3.7387 14.1079 3.80893 14.2847 3.80893C14.4615 3.80893 14.631 3.7387 14.7561 3.61367C14.8811 3.48865 14.9513 3.31908 14.9513 3.14227V2.57333H15.52C16.0008 2.5739 16.4617 2.76513 16.8016 3.10507C17.1415 3.44501 17.3328 3.90591 17.3333 4.38667V4.95253H1.33333V4.38667C1.3339 3.90591 1.52513 3.44501 1.86507 3.10507C2.20501 2.76513 2.66591 2.5739 3.14667 2.57333ZM1.33333 15.52V6.28587H17.3333V9.01573C16.18 8.24232 14.794 7.89329 13.4119 8.02824C12.0299 8.16319 10.7376 8.77376 9.75566 9.75566C8.77376 10.7376 8.16319 12.0299 8.02824 13.4119C7.89329 14.794 8.24232 16.18 9.01573 17.3333H3.14667C2.66592 17.3327 2.20504 17.1415 1.86511 16.8016C1.52517 16.4616 1.33393 16.0007 1.33333 15.52ZM14 18.6667C13.077 18.6667 12.1748 18.393 11.4073 17.8802C10.6399 17.3674 10.0418 16.6386 9.68856 15.7859C9.33535 14.9331 9.24294 13.9948 9.423 13.0896C9.60307 12.1843 10.0475 11.3528 10.7002 10.7002C11.3528 10.0475 12.1843 9.60307 13.0896 9.423C13.9948 9.24294 14.9331 9.33535 15.7859 9.68856C16.6386 10.0418 17.3674 10.6399 17.8802 11.4073C18.393 12.1748 18.6667 13.077 18.6667 14C18.6652 15.2372 18.173 16.4233 17.2982 17.2982C16.4233 18.173 15.2372 18.6652 14 18.6667Z"
                      fill="#2999BC"
                    />
                    <path
                      d="M14.6667 13.724V11.3333C14.6667 11.1565 14.5964 10.987 14.4714 10.8619C14.3464 10.7369 14.1768 10.6667 14 10.6667C13.8232 10.6667 13.6536 10.7369 13.5286 10.8619C13.4036 10.987 13.3333 11.1565 13.3333 11.3333V14C13.3333 14.0875 13.3505 14.1742 13.3841 14.2551C13.4176 14.336 13.4667 14.4095 13.5287 14.4713L14.862 15.8047C14.9877 15.9261 15.1561 15.9933 15.3309 15.9918C15.5057 15.9903 15.6729 15.9202 15.7965 15.7965C15.9202 15.6729 15.9903 15.5057 15.9918 15.3309C15.9933 15.1561 15.9261 14.9877 15.8047 14.862L14.6667 13.724Z"
                      fill="#2999BC"
                    />
                  </svg> */}
                  <BlueCalendarTimeIcon />
                </div>

                <div className="mx-2 font-medium text-2C495D">{formattedStartDate}</div>
              </div>

              <span className="mx-2">
                <i className={`bi bi-chevron-${showCalendar ? "up" : "down"} text-535252`}></i>
              </span>
            </button>
            {showCalendar && (
              <div className="flex justify-center mb-2">
                <DayPilotNavigator
                  selectMode={view}
                  showMonths={1}
                  skipMonths={1}
                  weekStarts={1}
                  onTimeRangeSelected={(args) => setStartDate(args.day)}
                  events={events}
                  // theme="navigator_custom"
                />
              </div>
            )}

            {(view === "Week" || view === "Day") && (
              <Fragment>
                <div className="bg-DCEEF8 border-b border-[#1D44691A] rounded-t-md py-1 px-3 flex justify-between items-center">
                  <div className="text-2C495D font-medium">All Events</div>

                  <div>
                    <button
                      type="button"
                      className="px-2 py-1 rounded bg-B9D6E5"
                      onClick={() => {
                        AllEventSearch();
                      }}
                    >
                      <i class="bi bi-search text-white"></i>
                    </button>
                    <button
                      type="button"
                      className="ms-1"
                      onClick={() => {
                        AllEventsExpand();
                      }}
                    >
                      {" "}
                      <i className={`bi bi-chevron-${showEvents ? "up" : "down"} text-535252`}></i>{" "}
                    </button>
                  </div>
                </div>

                {showEvents && (
                  <div className="border py-2 px-4 overflow-y-auto h-[35vh]">
                    {eventsSearch && (
                      <input
                        type="search"
                        className="rounded bg-white border border-1D446933 mb-3"
                        value={eventSearchQuery}
                        onChange={(e) => setEventSearchQuery(e.target.value)}
                      />
                    )}

                    <div>
                      {/* {allDayTask.length > 0 ? (
                                                                allDayTask.map((event, index) => (
                                                                  <Fragment key={index}>
                                                                    <div className='mb-2'>

                                                                      <span>10 Mar, 2024 | Wed</span>

                                                                      <div  className='p-2 border bg-284356 text-white text-xs rounded'>
                                                                        <div className='mb-1 capitalize bg-[#FFFFFF33] p-1 rounded'>{event?.text}</div>
                                                                        <div className='mb-1'>
                                                                          <i class="bi bi-calendar-week me-1"></i> {formatDate(event?.start_date)} - {formatDate(event?.end_date)}
                                                                        </div>
                                                                        <div className='mb-3'>
                                                                          <i class="bi bi-envelope-plus me-1"></i> {event?.owner}
                                                                        </div>
                                                                        <div className='my-2 mt-6'>
                                                                          <span className='px-2 py-1 border border-[#00000033] bg-[#00000033] rounded'>
                                                                            {event?.status}
                                                                          </span>
                                                                        </div>

                                                                      </div>

                                                                    </div>


                                                                  </Fragment>

                                                                ))
                                                              ) : (
                                                                <div className='text-center text-gray-500'>No All Day Events</div>
                                                              )}     */}

                      {/* {filteredTasks && filteredTasks.length > 0 ? (

                                                                    <Fragment>
                                                                        <span>{formattedStartDate}</span>

                                                                        {filteredTasks && filteredTasks?.map((event, index) => (
                                                                              <Fragment key={index}>
                                                                                <div className='mb-2'>
                                                                                  <div className='p-2 border bg-284356 text-white text-xs rounded'
                                                                                  onClick={() =>  { AllTaskEventsEdit(event) } }
                                                                                  >
                                                                                      <div className='flex'>


                                                                                            <div class="w-[30px] h-[24px] bg-white rounded-full flex justify-center items-center mr-2">
                                                                                              <p className='text-black font-500'>

                                                                                              <Tooltip title={event?.priority ? event?.priority : 'Sub Task'} placement="left" arrow  componentsProps={{
                                                                                                      tooltip: {
                                                                                                        sx: {
                                                                                                          bgcolor: 'common.white',
                                                                                                          filter: 'drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))',
                                                                                                          color: '#383838',
                                                                                                          '& .MuiTooltip-arrow': {
                                                                                                            color: 'common.white',
                                                                                                            filter: 'drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))',
                                                                                                          },
                                                                                                        },
                                                                                                      },
                                                                                              }}>

                                                                                                      {event?.priority ? event?.priority?.[0] : <span><i class="bi bi-diagram-3 text-lg"></i></span>}


                                                                                              </Tooltip>


                                                                                              </p>
                                                                                            </div>
                                                                                          <div className='w-full mb-1 capitalize bg-[#FFFFFF33] py-1 px-3 rounded'>{event?.text}</div>
                                                                                      </div>


                                                                                    <div className='mb-1'>
                                                                                      <i className="bi bi-calendar-week me-1 text-lg mr-2"></i> {formatDate(event.start_date)} - {formatDate(event.end_date)}
                                                                                    </div>



                  <div className="mb-3">

                    <div className="flex">
                       <i className="bi bi-person-plus me-1 text-lg mr-2"></i>

                      {event?.assigned_to?.slice(0, 3).map((person, i) => (
                        <Tooltip key={i} title={person.name} arrow>
                          <div className="w-[30px] h-[30px] bg-white rounded-full flex justify-center items-center mr-2">
                            <p className="text-black font-bold">{getInitials(person.name)}</p>
                          </div>
                        </Tooltip>
                      ))}


                      {event?.assigned_to?.length > 3 && (
                        <Tooltip title={`${event.assigned_to.length - 3} more`} arrow>
                          <div className="w-[30px] h-[30px] bg-gray-300 text-black rounded-full flex justify-center items-center">
                            +{event.assigned_to.length - 3}
                          </div>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                                                                                    <div className='my-2 mt-6 flex justify-between'>
                                                                                        <span className='px-2 py-1 border border-[#00000033] bg-[#00000033] rounded'>
                                                                                                Not Started
                                                                                        </span>


                                                                                    </div>

                                                                                  </div>
                                                                                </div>
                                                                              </Fragment>
                                                                          ))}

                                                                    </Fragment>

                                                                ) : (
                                                                  <div className='text-center text-gray-500'>No All Day Events</div>
                                                          )}       */}

                      {filteredTasks && filteredTasks.length > 0 ? (
                        <Fragment>
                          {/* Sort tasks by start date */}
                          {Object.entries(
                            filteredTasks
                              .sort((a, b) => new Date(a.start_date) - new Date(b.start_date)) // Sort tasks by start date in ascending order
                              .reduce((acc, event) => {
                                const dateKey = formatDate(event.start_date); // Group by formatted start date
                                if (!acc[dateKey]) acc[dateKey] = []; // If date doesn't exist, create an array
                                acc[dateKey].push(event); // Push the event into the array for that date
                                return acc;
                              }, {})
                          ).map(([date, tasks], index) => (
                            <Fragment key={index}>
                              {/* Display the formatted date at the top of the first card for each group */}
                              <span>{date}</span>
                              {tasks.map((event, taskIndex) => (
                                <Fragment key={taskIndex}>
                                  <div className="mb-2">
                                    <div
                                      className={`p-2 border ${event?.parent_task_id ? "bg-535252" : "bg-284356"}  text-white text-xs rounded`}
                                      onClick={() => {
                                        AllTaskEventsEdit(event);
                                      }}
                                    >
                                      <div className="flex">
                                        <div className="w-[30px] h-[24px] bg-white rounded-full flex justify-center items-center mr-2">
                                          <p className="text-black font-500">
                                            <Tooltip
                                              title={event?.parent_task_id ? "Sub Task" : event?.priority}
                                              placement="left"
                                              arrow
                                              componentsProps={{
                                                tooltip: {
                                                  sx: {
                                                    bgcolor: "common.white",
                                                    filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                                    color: "#383838",
                                                    "& .MuiTooltip-arrow": {
                                                      color: "common.white",
                                                      filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                                                    },
                                                  },
                                                },
                                              }}
                                            >
                                              {event?.parent_task_id ? (
                                                <span>
                                                  <SubTaskIcon />
                                                </span>
                                              ) : (
                                                event.priority?.[0]
                                              )}
                                            </Tooltip>
                                          </p>
                                        </div>
                                        <div className="w-full mb-1 capitalize bg-[#FFFFFF33] py-1 px-3 rounded">
                                          {event.text}
                                        </div>
                                      </div>
                                      <div className="mb-1">
                                        <i className="bi bi-calendar-week me-1 text-lg mr-2"></i>{" "}
                                        {formatDate(event.start_date)} - {formatDate(event.end_date)}
                                      </div>
                                      <div className="mb-3">
                                        <div className="flex">
                                          {event?.assigned_to?.slice(0, 3).map((person, i) => (
                                            <Fragment>
                                              <i className="bi bi-person-plus me-1 text-lg mr-2"></i>

                                              <Tooltip key={i} title={person.name} arrow>
                                                <div className="w-[30px] h-[30px]  flex justify-center items-center mr-2">
                                                  {/* <p className="text-black font-bold">{getInitials(person.name)}</p> */}
                                                  <AvatarName
                                                    name={getInitials(person.name)}
                                                    size="medium"
                                                    bgColor={"#ffffff"}
                                                    textColor={"#000000"}
                                                    // borderColor={"#AAC9DB"}
                                                  />
                                                </div>
                                              </Tooltip>
                                            </Fragment>
                                          ))}
                                          {/* If more than 3, show +X icon */}
                                          {event?.assigned_to?.length > 3 && (
                                            <Tooltip title={`${event.assigned_to.length - 3} more`} arrow>
                                              <div className="w-[30px] h-[30px] bg-gray-300 text-black rounded-full flex justify-center items-center">
                                                +{event.assigned_to.length - 3}
                                              </div>
                                            </Tooltip>
                                          )}
                                        </div>
                                      </div>
                                      <div className="my-2 mt-6">
                                        {event.statuses &&
                                          event.statuses.length > 0 &&
                                          event.statuses.map(
                                            (status, index) =>
                                              status.status && (
                                                <span
                                                  key={index}
                                                  className="px-2 py-1 border border-[#00000033] bg-[#00000033] rounded"
                                                >
                                                  {status.status}
                                                </span>
                                              )
                                          )}
                                      </div>
                                    </div>
                                  </div>
                                </Fragment>
                              ))}
                            </Fragment>
                          ))}
                        </Fragment>
                      ) : (
                        <div className="text-center text-gray-500">No All Day Events</div>
                      )}
                    </div>
                  </div>
                )}
              </Fragment>
            )}
          </div>
        </div>
      </div>

      {modalOpen?.is_recurrence === 1 && (
        <EditOptionsTaskPodModal
          onClose={() => setModalOpen(false)}
          onOpen={modalOpen}
          onSave={handleEditFields}
          refetch={taskRecurrenceFetch}
        />
      )}

      {modalOpen?.is_recurrence === 0 && (
        <AddTaskPodModal closePopup={() => setModalOpen(false)} taskid={modalOpen} refetch={taskRecurrenceFetch} />
      )}

      {modalOpen?.model === "addmodel" && (
        <AddTaskPodModal closePopup={() => setModalOpen(false)} taskid={modalOpen} refetch={taskRecurrenceFetch} />
      )}

      {hoveredTask && (
        <div
          className="absolute z-50 p-2 bg-white border rounded shadow-md"
          style={{
            top: mousePos.y + 10,
            left: mousePos.x + 10,
            pointerEvents: "none",
          }}
        >
          <div className="flex flex-col">
            <strong>Task:</strong> {hoveredTask?.subject}
            {/* subject,start_date,end_date,start_time,end_time,category_id,sub_tasks,assigned_to */}
            <strong>start_date</strong>
            {hoveredTask?.start_date} {hoveredTask?.start_time}
            <strong>End date</strong>
            {hoveredTask?.end_date} {hoveredTask?.end_time}
            <strong>Category</strong>
            {hoveredTask?.category_id}
            <strong>sub_tasks</strong>
            {hoveredTask?.sub_tasks}
            <strong>assigned_to</strong>
            {hoveredTask?.assigned_to}
          </div>
          {/* you can also find task by ID from `events` */}
        </div>
      )}
    </div>
  );
};

export default TaskPodRecurrenceCalendar;
